import { render, staticRenderFns } from "./StudentGroupFilter.vue?vue&type=template&id=684278b2"
import script from "./StudentGroupFilter.vue?vue&type=script&lang=js"
export * from "./StudentGroupFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports